import { useCallback, useState } from 'react';

const useBonusSliderAtEnd = () => {
  const [atEnd, setAtEnd] = useState(false);

  const onSwiper = useCallback(swiper => {
    if (!swiper) {
      return;
    }

    const sync = () => {
      setAtEnd(Boolean(swiper.isEnd));
    };

    sync();
    swiper.on('resize', sync);
    swiper.on('slideChange', sync);
    swiper.on('slideChangeTransitionEnd', sync);
  }, []);

  return { atEnd, onSwiper };
};

export default useBonusSliderAtEnd;
